import React, { FC, ReactNode, ReactNodeArray } from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@cld/component-enhancer';
import { CommonComponentProps, StylableComponentProps } from '@cld/common-definitions';
import { chipTheme } from './theme';
import { Root as ChipRoot } from './Chip.styled';

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin-top: -${chipTheme.list.spacing};

  > ${ChipRoot} {
    margin-top: ${chipTheme.list.spacing};
  }

  > ${ChipRoot}:not(:last-child) {
    margin-right: ${chipTheme.list.spacing};
  }
`;

export interface ChipsListProps extends CommonComponentProps<'div'>, StylableComponentProps {
  /** Chips to include in a list */
  children?: ReactNodeArray | ReactNode;
}

/** The purpose of this component is to display list of `Chip` component with the spacing between `Chip`s */
export const ChipsList = asStyledComponent<FC<ChipsListProps>>(({ children, className, rootProps }) => (
  <Root className={className} {...rootProps}>
    {children}
  </Root>
));
